import { render, staticRenderFns } from "./DivergenciasBI.vue?vue&type=template&id=69d9c13a"
import script from "./DivergenciasBI.vue?vue&type=script&lang=js"
export * from "./DivergenciasBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports